<template>
    <div class="">
        <div class="navbar navbar-dark">
            <div class="container d-flex justify-content-between">
                <div></div>
                <a href="#" class="navbar-brand d-flex align-items-center">
                    <img src="@/assets/logo.png" width="180px" />
                </a>

                <span @click="showMenu()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="27" viewBox="0 0 32 27">
                    <g id="menu_icon" data-name="menu icon" transform="translate(32 27) rotate(180)">
                      <path id="menu_icon-2" data-name="menu icon" d="M1,27a1,1,0,0,1-1-1V24.142a1,1,0,0,1,1-1H31a1,1,0,0,1,1,1V26a1,1,0,0,1-1,1ZM1,15.429a1,1,0,0,1-1-1V12.571a1,1,0,0,1,1-1H19a1,1,0,0,1,1,1v1.858a1,1,0,0,1-1,1ZM1,3.857a1,1,0,0,1-1-1V1A1,1,0,0,1,1,0H31a1,1,0,0,1,1,1V2.858a1,1,0,0,1-1,1Z" fill="#700e57"/>
                    </g>
                  </svg> 
                </span> 
            </div>
        </div> 

        <div class="container mt-5">
            <div class="d-flex justify-content-center mb-5"> 
                  <div class="input-group" style="width: 100%; max-width: 600px">
                    <div class="input-group-prepend"> 
                      <div class="input-group-text m-2 d-none d-sm-block" style="    
                            background: rgb(112, 14, 87);
                            border-radius: 14px;
                            padding-top: 10px;
                            height: 47px;
                            border: 0;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
                          <g id="Group_9" data-name="Group 9" transform="translate(-144 -424)">
                            <rect id="Rectangle_7" data-name="Rectangle 7" width="30" height="30" rx="4" transform="translate(144 424)" fill="#fff" opacity="0"/>
                            <g id="Group_8" data-name="Group 8" transform="translate(151.429 428.953)">
                              <g id="Ellipse_1" data-name="Ellipse 1" fill="none">
                                <path d="M14.859,7.429c0,5.341-7.429,12.382-7.429,12.382S0,12.771,0,7.429a7.429,7.429,0,0,1,14.859,0Z" stroke="none"/>
                                <path d="M 7.4293212890625 1.30000114440918 C 4.049601554870605 1.30000114440918 1.30000114440918 4.049601554870605 1.30000114440918 7.4293212890625 C 1.30000114440918 9.31870174407959 2.484511375427246 11.86921119689941 4.725471496582031 14.80513191223145 C 5.725114822387695 16.11477661132812 6.735180854797363 17.23330879211426 7.429622650146484 17.96322250366211 C 8.11772346496582 17.2401294708252 9.116296768188477 16.13441467285156 10.1114616394043 14.83354187011719 C 12.36662101745605 11.88561153411865 13.55864143371582 9.325271606445312 13.55864143371582 7.4293212890625 C 13.55864143371582 4.049601554870605 10.80904197692871 1.30000114440918 7.4293212890625 1.30000114440918 M 7.4293212890625 1.9073486328125e-06 C 11.53242111206055 1.9073486328125e-06 14.85864162445068 3.326221466064453 14.85864162445068 7.4293212890625 C 14.85864162445068 12.7706413269043 7.4293212890625 19.81152153015137 7.4293212890625 19.81152153015137 C 7.4293212890625 19.81152153015137 9.5367431640625e-07 12.7706413269043 9.5367431640625e-07 7.4293212890625 C 9.5367431640625e-07 3.326221466064453 3.326221466064453 1.9073486328125e-06 7.4293212890625 1.9073486328125e-06 Z" stroke="none" fill="#fff"/>
                              </g>
                              <g id="Ellipse_2" data-name="Ellipse 2" transform="translate(4.442 3.932)" fill="none" stroke="#fff" stroke-width="1.3">
                                <circle cx="2.987" cy="2.987" r="2.987" stroke="none"/>
                                <circle cx="2.987" cy="2.987" r="2.337" fill="none"/>
                              </g>
                            </g>
                          </g>
                        </svg>

                      </div>
                    </div>
                    
                    <input type="text" class="form-control search-control m-2 shadow-sm" @keyup="searchPlace()"  v-model="filter.search" @input="getProvince()" 
                      :placeholder="$t('Please_Select_or_search_your_location')">
                       
                     
                      
                    <div class="icon-search-group">  
                      <span style="background: white;padding: 3px;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15.351" height="15.31" viewBox="0 0 15.351 15.31">
                          <g id="Search_icon" data-name="Search icon" transform="translate(-36.507 -97.5)">
                            <path id="Vector" d="M12.036,6A6.018,6.018,0,1,1,6.018,0,6.009,6.009,0,0,1,12.036,6Z" transform="translate(37.257 98.25)" fill="none" stroke="#b7c4e0" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                            <path id="Vector-2" data-name="Vector" d="M3.272,3.263,0,0" transform="translate(47.525 108.487)" fill="none" stroke="#b7c4e0" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                          </g>
                        </svg> 
                      </span>
                    </div>


                     <div v-if="search_hotel.length > 0 && drop_search"  v-click-outside="closeDropDown"  class="drop-search-item shadow-sm" 
                      style=" margin-top: 62px;  "
                       >
                          <div v-for="sl in search_hotel" :key="sl.id" class="item">  
                            <p @click="openSearch(sl)">
                              <img v-if="sl.type === 'hotel'" src="@/assets/media/icons/stockholm/Home/Bed.svg" alt />
                              <img v-else-if="sl.type === 'PROVINCE'" src="@/assets/icon/icon01.svg"  width="20" alt /> 
                              <img v-else src="@/assets/media/icons/stockholm/Cooking/Dinner.svg" alt />  
                              {{ sl.title}}
                            </p> 
                          </div>
                        </div>

                  

                  </div>  

                  <!-- drop list -->
             

            </div> 
            <!-- </div>   --> 
        </div>
        <menu-scroll :data="provinces" @input="menuSelected"></menu-scroll> 
        <div class="container mt-5">
            <div class="row">
                <div class="col-md-6 col-lg-4 col-sm-6 col-xs-6" v-for="province of provinces.provinces" :key="province.id">
                    <div class="card-flyer" @click="openProvince(province)">
                        <div class="text-box">
                            <div class="image-box" :style=" ` 
                                background-image: url(${province.image_url ? province.image_url : require('@/assets/background.svg') });  
                                background-size: 100%;
                              `"> 
                            </div>
                            <!-- <div v-else style="height: 240px; width: 240px">
                                <img src="@/assets/background.svg" alt="" style="height: 240px; width: 240px">
                            </div> -->
                            <div class="text-container" > 
                                <h6>{{ province.name}}  </h6> 
                            </div>
                            <div class="blur"></div>
                        </div>
                    </div>
                </div>

              <div class="col-12">
                <div  v-if="(emptyProvince)"   class="mt-20 text-center mt-5">
                      <div>
                        <img src="@/assets/icon/icon01.svg" width="100" alt="">
                      </div>
                    <p class="mt-2"> 
                      {{ $t("Province is not found!") }}
                    </p>
                  </div>
              </div>


            </div>
        </div> 
        ​
    </div>
</template>
<style lang="css">
    
    .image-box{
      height: 270px; 
      border-radius: 10px; 
      background-size: 100%;
      background-repeat: no-repeat;
    }
    .hide {
        display: none;
    }
    .card-flyer:hover + .hide {
        display: block !important;
    }

    .open_province {
        position: absolute;
        right: 0;
        padding: 10px 10px;
        float: right;
        margin-top: -63px;
        background: white;
        margin-right: 15px;
    }
    .bd-footer {
        font-size: 0.875rem;
        text-align: center;
        background-color: #f7f7f7;
    }
    .card-flyer {   
        margin-bottom: 30px;
    }
    .card-flyer .image-box { 
        overflow: hidden; 
    }
    .card-flyer .image-box img { 
        width: 100%;
        height: 100%;
        border-radius: 10px;
    }
    .card-flyer:hover .image-box img {
        opacity: 0.7;
        -webkit-transform: scale(1.15);
        -moz-transform: scale(1.15);
        -ms-transform: scale(1.15);
        -o-transform: scale(1.15);
        transform: scale(1.15);
        border-radius: 10px;
    }

    .card-flyer .text-box .text-container {
        padding: 11px 18px; 
        cursor: pointer;
        margin-top: -47px;
        z-index: 1;
        position: relative;
    }
    .blur{
      filter: blur(0);
      height: 48px;
      background: #6c757dcc;
      margin-top: -46px;
      border-radius: 0px 0px 10px 10px;
    }
    .card-flyer {
        background: #ffffff;
        -webkit-transition: all 0.2s ease-in;
        -moz-transition: all 0.2s ease-in;
        -ms-transition: all 0.2s ease-in;
        -o-transition: all 0.2s ease-in;
        transition: all 0.2s ease-in;
    } 
    .card-flyer .text-box p {
        margin-top: 10px;
        margin-bottom: 0px;
        padding-bottom: 0px;
        font-size: 14px;
        letter-spacing: 1px;
        color: #000000;
    }
    .card-flyer .text-box h6 {
        margin-top: 0px;
        margin-bottom: 4px;
        font-size: 16px; 
        color: white;
        font-family: "Roboto Black", sans-serif;
        letter-spacing: 1px;
    }
</style>

<script> 
import store from "@/store";
import scroll_memu from '../ui_components/scroll_memu.vue';
export default {
  components: { scroll_memu },
        name: "province",
        layout: "default",
        metaInfo: {
            title: "DiscoverLao Ordering",
        }, 
        data: ()=>({
            filter: {},
            drop_search: false,
        }),
        computed: {
            search_hotel() {
              return store.getters["main_location/search_hotel"];
            },
            provinces() {
                return store.getters["province/provinces"] ;
            },
            emptyProvince(){
              if(this.provinces.provinces){
                if(this.provinces.provinces.length ==  0) return true
              }
              return false
            },
            seletedFilters(){
              return store.getters['main_location/seletedFilters']
            }
            
        },
        mounted() {
            let select = this.seletedFilters  
            if(select.cuisines.id){
                this.filter.cuisines = select.cuisines.id
            } 
            if(select.meal.id){
                this.filter.meal_types = select.meal.id
            }   
            this.getProvince();
        },
        methods: {
             async openSearch(place) {
              // this.placeBeforeSubmit = place;
              // if (this.order.length > 0 && this.placeSelected.id !== place.id) {
              //   this.modalChange = true;
              //   return;
              // }
              // this.type_selected = place.type;

              if(place.type == 'hotel')
                this.$router.push({ name: "hotel_detail",  params: { slug: place.slug }}); 
              else if(place.type == 'PROVINCE'){ 
                this.$router.push({ name: "listing",  params: { slug: place.slug }}); 
              } 
              else  
                this.$router.push({ name: "detail", params: { id: place.slug } });
                
            },
            async searchPlace() {
              this.drop_search = true;
              if (this.filter.search.length < 3) {
                await store.dispatch("main_location/clearSearch");
                return;
              }
              await store.dispatch("main_location/searchSuggestion", this.filter);
            },
            closeDropDown() {
              this.drop_search = false;
            },
            menuSelected(event){

                if(event.cuisines.id){
                    this.filter.cuisines = event.cuisines.id
                }else {
                  this.filter.cuisines = ''
                }
                if(event.meal.id){
                  this.filter.meal_types = event.meal.id
                } else{
                  this.filter.meal_types=  ''
                }
                 
                this.getProvince();
            },
            async getProvince() {
              
                await store.dispatch("province/getProvince", this.filter);
            },
            openProvince(province) {
                this.$store.dispatch("province/setProvince", province);
                return this.$router.push({ name: "listing",  params: { slug: province.slug }});
            },
            async showMenu() {
                await store.dispatch("nav/nav_menu");
            },
        }, 
    };
</script>
